<template>
  <base-box class="box-coupon no-shadow">
    <div class="d-flex align-center justify-between">
      <div class="d-flex align-center">
        <i class="ticket-icon fas fa-paper-plane"></i>
        <p class="coupon-code field-title">{{ oCoupon.code }}</p>
      </div>
      <div class="d-flex flex-column sales">
        <p>Valor em Vendas</p>
        <div>
          <p>{{ couponSalesValue }}</p>
        </div>
      </div>
    </div>

    <div class="line mb_25"></div>

    <div class="d-flex align-center justify-between mb_25">
      <div>
        <p class="field-title">Data de Envio</p>
        <p>{{ campaignDate }}</p>
      </div>
      <div class="text-right">
        <p class="field-title">Grupo de envio</p>
        <p>{{ campaignTarget }}</p>
      </div>
    </div>

    <div class="d-flex align-center justify-between mb_30">
      <div>
        <p class="field-title">Data de expiração</p>
        <p>{{ couponExpiration }}</p>
      </div>
      <div class="text-right">
        <p class="field-title">Benefício oferecido</p>
        <p>{{ couponAmount }}</p>
      </div>
    </div>

    <div class="funnels d-flex align-center mb_30">
      <div class="funnel w-100">
        <div class="funnel-value">
          <p>
            {{ campaign && campaign.total_users ? campaign.total_users : 0 }}
          </p>
        </div>
        <div class="d-flex align-center funnel-name">
          <i class="fas fa-users" />
          <p class="ml_10">Público</p>
        </div>
      </div>
      <div class="line"></div>
      <div class="funnel w-100" :class="{ new: !wasCampaingSent }">
        <div class="funnel-value" :class="{ new: !wasCampaingSent }">
          <p>{{ !wasCampaingSent ? "---" : campaign.total_clicks }}</p>
        </div>
        <div
          class="d-flex align-center funnel-name"
          :class="{ new: !wasCampaingSent }"
        >
          <i class="fas fa-mouse-pointer" />
          <p class="ml_10">Cliques</p>
        </div>
      </div>
      <div class="line" :class="{ new: !wasCampaingSent }"></div>
      <div class="funnel w-100" :class="{ new: !wasCampaingSent }">
        <div class="funnel-value" :class="{ new: !wasCampaingSent }">
          <p>{{ !wasCampaingSent ? "---" : couponReport.total }}</p>
        </div>
        <div
          class="d-flex align-center funnel-name"
          :class="{ new: !wasCampaingSent }"
        >
          <i class="fas fa-analytics" />
          <p class="ml_10">Usos</p>
        </div>
      </div>
    </div>

    <div class="d-flex justify-center flex-column align-center">
      <p
        @click="changeRoute('resultados-cupom', { code: oCoupon.code })"
        class="see-details"
      >
        Ver detalhes
      </p>
      <div />
    </div>
  </base-box>
</template>
<script>
import BaseTitle from "@/components/Title";
import BaseBox from "@/components/Box";

import dayjs from "dayjs";
import Gift, { TYPE as aTypes, DivulgationType } from "easyjs/lib/Schema/Gift";
import { CampaignType, CampaignRunAt } from "easyjs/lib/Schema/Marketing";

import ApiReports from "@/api/reports";
import MarketingAPI from "@/api/marketing";

import Utils from "@/utils";

export default {
  props: {
    coupon: { type: Object, required: true, default: {} },
  },
  data() {
    return {
      oCoupon: {},
      campaign: {},
      couponReport: {
        total: 0,
        sales: 0,
      },
    };
  },
  created() {
    this.oCoupon = Gift.fromObject(this.coupon);
    this.getCampaign();
    this.getCouponUseReport();
  },
  methods: {
    changeRoute(routeName, params = {}) {
      this.$router.push({ name: routeName, params });
    },
    getCampaign() {
      return MarketingAPI.campaignByGift(this.oCoupon.id).then((response) => {
        this.campaign = response.getData({}).campaign;
      });
    },
    getCouponUseReport() {
      const esFilter = {
        query: [
          {
            index: "report-orders",
            type: "aggs",
            queries: [
              {
                query_string: {
                  query: `${this.oCoupon.code}`,
                  fields: ["gift.code"],
                },
              },
            ],
            aggs: {
              couponUse: {
                date_range: {
                  field: "created_at",
                  ranges: [
                    {
                      from: "1901-01-01",
                      to: dayjs().format("YYYY-MM-DDTHH:mm:ssZ[Z]"),
                    },
                  ],
                },
                aggs: {
                  total: {
                    nested: {
                      path: "payers",
                    },
                    aggs: {
                      total: {
                        sum: {
                          field: "payers.amount",
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      };

      ApiReports.reports(esFilter).then((response) => {
        const bucket = response.data[0].couponUse.buckets[0];

        this.couponReport.total = bucket.total.doc_count;
        this.couponReport.sales = bucket.total.total.value;
      });
    },
  },
  computed: {
    couponAmount() {
      if (this.oCoupon.typeIs(aTypes["DELIVERY"])) {
        return "Entrega Grátis";
      }

      if (this.oCoupon.typeIs(aTypes["PERCENT"])) {
        return `${this.oCoupon.value}%`;
      }

      if (this.oCoupon.typeIs(aTypes["PRICE"])) {
        return Utils.convertMoney(this.oCoupon.value, "R$", "");
      }
    },
    couponSalesValue() {
      return Utils.convertMoney(this.couponReport.sales);
    },
    couponExpiration() {
      return this.oCoupon.expiration
        ? Utils.ts2Date(this.oCoupon.expiration, false)
        : "---";
    },
    campaignDate() {
      return this.campaign && this.campaign.date
        ? `${dayjs(this.campaign.date).utc().format("DD/MM/YYYY")} ${
            this.campaignRunAt
          }`
        : "";
    },
    campaignRunAt() {
      switch (this.campaign.run_at) {
        case CampaignRunAt.LUNCH:
          return "(Almoço)";
        case CampaignRunAt.BREAKFAST:
          return "(Café)";
        case CampaignRunAt.DINNER:
          return "(Jantar)";
      }
    },
    campaignTarget() {
      const target = this.campaign ? this.campaign.alias : "";
      switch (target) {
        case CampaignType.LAST15DAYS:
          return "Não pedem a 15 dias";
        default:
          return "Toda a base de clientes";
      }
    },
    wasCampaingSent() {
      return this.campaign && !!this.campaign.last_run;
    },
  },
  components: {
    BaseTitle,
    BaseBox,
  },
};
</script>
<style scoped>
.box-coupon > div:first-child {
  margin-bottom: 20px;
}
.coupon-code {
  font-size: 1.6em !important;
  color: var(--default-hover) !important;
}
.field-title {
  text-transform: uppercase;
  color: #bfbfbf;
  font-weight: bold;
  font-size: 1.2em;
}
.field-title + p {
  font-size: 1.2em;
  color: #bfbfbf;
  margin-top: 5px;
}
.ticket-icon {
  color: var(--default-hover);
  margin-right: 15px;
  font-size: 1.9em;
}
.sales {
  align-items: flex-end;
}
.sales p:first-child {
  font-size: 1.2em;
  color: #c9c9c9c7;
  text-transform: uppercase;
  margin-bottom: 5px;
}
.sales div {
  background: var(--background-up);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 27px;
}
.sales p:last-child {
  text-align: center;
  font-size: 1.4em;
  font-weight: bold;
  color: #0dc59de3;
  text-transform: uppercase;
  padding: 5px 15px;
  margin: 0;
}
.line {
  width: 100%;
  border-bottom: 1px solid #ffffff17;
}
.see-details {
  cursor: pointer;
  font-size: 1.2em;
  color: #ffffff;
  text-transform: uppercase;
}

.see-details + div {
  margin-top: 5px;
  margin-bottom: 4px;
  background: #fff;
  height: 1px;
  width: 85px;
  opacity: 0;
}
.see-details:hover + div {
  opacity: 1;
}

.funnel {
  border-radius: 5px;
}
.funnel.new {
  border-color: transparent;
}
.funnel-value {
  background: #45484dc9;
  padding: 15px 20px;
  color: var(--default);
  border-radius: 5px 5px 0px 0px;
  min-height: 50px;
  border: 1px solid #ff338261;
  border-bottom: none;
}
.funnel-value.new,
.funnel-name.new {
  border: none;
}
.funnel-value p {
  font-size: 2em;
  font-weight: 900;
}
.funnel-value.new p {
  font-size: 1.6em;
  font-weight: normal;
}
.funnel-value.new {
  text-align: center;
  background: #3f4146;
  color: #999;
}
.funnel-name {
  background: #48464d;
  padding: 10px 20px;
  color: var(--default-hover);
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #ff338261;
  border-top: none;
}

.funnel-name.new {
  background: #414348;
  height: 36px;
}
.funnel-name i {
  font-size: 1.4em;
  opacity: 0.55;
  color: var(--default);
}
.funnel-name p {
  text-transform: uppercase;
  font-size: 1.2em;
  font-weight: bold;
}
.funnels .line {
  border: none;
  border-bottom: 2px dotted var(--default);
  height: 0px;
  width: 40px;
}
.funnels .line.new {
  border-color: #999999;
}
@media screen and (max-width: 991px) {
  .box-coupon > div:first-child {
    margin-bottom: 20px;
  }
  .funnels {
    flex-direction: column;
  }
  .funnel-value {
    min-height: auto;
  }
  .funnel-value p {
    font-size: 1.5em;
  }
  .funnel.new {
    border: none;
  }
  .funnel-name {
    padding: 5px 20px;
  }
  .funnel-name i {
    font-size: 1.2em;
  }
  .funnel-name p {
    font-size: 1.2em;
  }
  .funnels .line {
    border: none;
    border-left: 2px solid var(--default);
    height: 20px;
    width: 0px;
  }
  .field-title,
  .field-title + p {
    font-size: 1em;
  }
  .see-details {
    font-size: 1.2em;
  }
}
</style>
